
import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

interface UseDataRefreshProps {
  fetchUserProfile: () => Promise<string | null>;
  refreshSubscriptionStatus: () => Promise<void>;
}

export const useDataRefresh = ({ 
  fetchUserProfile,
  refreshSubscriptionStatus 
}: UseDataRefreshProps) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const refreshUserData = useCallback(async () => {
    setLoading(true);
    
    try {
      const userId = await fetchUserProfile();
      
      if (!userId) {
        toast.error("You need to be logged in to view this page");
        navigate("/auth");
        return;
      }
      
      await refreshSubscriptionStatus();
    } catch (error) {
      console.error("Unexpected error in fetchUserData:", error);
      toast.error("Error loading account data");
    } finally {
      setLoading(false);
    }
  }, [fetchUserProfile, navigate, refreshSubscriptionStatus]);
  
  return {
    loading,
    setLoading,
    refreshUserData
  };
};
